import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import sanitizeContent from '@sv-support-sdk/utils/src/helpers/sanitizeContent';

import Avatar, { IAvatarProps } from '@sv-support-sdk/ui-components/src/components/Media/Avatar';

import css from './style.module.scss';
import Reply from '../Reply';

interface IProps {
  children?: ReactNode;
  date?: string;
  avatar?: IAvatarProps;
  type?: 'fromUser';
  className?: string;
  htmlMessage?: string;
  offset?: '8-0';
  replyMessage?: string;
}

const Message: FC<IProps> = ({
  children,
  date,
  type,
  avatar,
  className,
  htmlMessage,
  offset,
  replyMessage,
}) => (
  <div
    className={classNames(
      css.message,
      {
        [css[`message_type_${type}`]]: type,
        [css[`message_offset_${offset}`]]: offset,
      },
      className,
    )}
  >
    {avatar && (
      <div className={css.message__avatar}>
        <Avatar {...avatar} />
      </div>
    )}
    <div className={css.message__body}>
      {replyMessage && htmlMessage && (
        <div className={css.message__content}>
          <Reply>{replyMessage}</Reply>
          <div dangerouslySetInnerHTML={sanitizeContent(htmlMessage)} />
        </div>
      )}
      {htmlMessage && !replyMessage && (
        <div
          className={css.message__content}
          dangerouslySetInnerHTML={sanitizeContent(htmlMessage)}
        />
      )}
      {children && <div className={css.message__content}>{children}</div>}
      {date && <div className={css.message__date}>{date}</div>}
    </div>
  </div>
);

export default Message;
